export const breakpoints = {
  values: {
    xs: 0,
    sm: 375,
    md: 900, // Not in use, but required by theme
    lg: 1280,
    xl: 1440,
  },
};
